module.exports = __webpack_public_path__ + "img/examples2.7e19365c.png";